import React from 'react'
import styled from 'styled-components'

import { primary } from 'styles/colors'

const Wrapper = styled.div`
  height: 22px;
  width: 22px;
  border-radius: 50%;
  color: white;
  background-color: ${primary};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
`

const Notifications = ({ count, className }) => (
  <Wrapper className={className}>
    <span>{count}</span>
  </Wrapper>
)

export default Notifications



// WEBPACK FOOTER //
// ./src/components/Notifications.js